import React from 'react';
import RatingStars from '@gumtree/ui-library/src/rating-stars/rating-stars';
import { 
    ScoreWrapper, 
    ScoreValue, 
    OutOfText, 
    StarsContainer, 
    starsContainerCss,
    ReviewsCount 
} from './index.style';

export interface AdReviewsScoreProps {
    total: number;
    average: number;
    isMobile: boolean;
}

const AdReviewsScore: React.FC<AdReviewsScoreProps> = ({ total, average, isMobile }) => {
    return (
        <ScoreWrapper>
            <ScoreValue>{average.toFixed(1)}</ScoreValue>
            {!isMobile && <OutOfText>out of 5</OutOfText>}
            <StarsContainer css={starsContainerCss}>
                <RatingStars rating={average.toFixed(1)} />
            </StarsContainer>
            <ReviewsCount>{total} reviews</ReviewsCount>
        </ScoreWrapper>
    );
};

export default AdReviewsScore;
